import { CSSObject } from '@emotion/react'
import { Color, Size } from '@opallabs/gem'
import { colors } from '../../gem'
import { Status } from './types'
import type { StyleProps } from './types'

function chooseColor({
  status,
  theme,
}: Omit<StyleProps, 'alwaysVisibleWhenActive'>): string {
  switch (status) {
    case Status.Invalid:
      return Color[theme].Surface.R100
    case Status.Invisible:
      return 'transparent'
    // intentional fallthrough
    case Status.Pending:
    case Status.RequiredButNotValidated:
      return colors[theme].secondary.yellow100
    case Status.Valid:
      return Color[theme].Surface.G100
  }
}

export const indicator = ({
  alwaysVisibleWhenActive,
  status,
  theme,
}: StyleProps): CSSObject => ({
  backgroundColor: chooseColor({
    status,
    theme,
  }),
  blockSize: Size.StatusIndicator,
  borderRadius: '50%',
  boxSizing: 'border-box',
  display:
    status === Status.Valid && !alwaysVisibleWhenActive ? 'none' : 'flex',
  inlineSize: Size.StatusIndicator,
})
